<div class="row">
  <ng-container *ngIf="selectedUsers.length === 0">
    <div class="col-4">
      <nb-select fullWidth [(ngModel)]="searchBy" placeholder="جستجو بر اساس">
        <nb-option value="userID">شناسه کاربری</nb-option>
        <nb-option value="name">نام و نام‌خانوادگی</nb-option>
        <nb-option value="email">ایمیل</nb-option>
        <nb-option value="phone">شماره تلفن</nb-option>
        <nb-option value="nationalID">کدملی</nb-option>
        <nb-option value="card">شماره کارت</nb-option>
        <nb-option value="iban">شماره شبا</nb-option>
      </nb-select>
    </div>
    <div class="col-6">
      <input nbInput [type]="searchBy === 'email' || searchBy === 'name' || searchBy === 'iban' ? 'text' :'number' "
             dir="auto"
             fullWidth status="basic" [(ngModel)]="searchQuery" [disabled]="!searchBy"
             [placeholder]="searchBy | userSearchQueryPlaceholder">
    </div>
    <div class="col-2">
      <button nbButton [disabled]="fetchUser" [nbSpinner]="fetchUser" fullWidth status="primary"
              (click)="filter(searchQuery, searchBy)">جستجو
      </button>
    </div>
  </ng-container>
</div>
<div class="row mt-3">
  <div class="col-12 h-100">
    <nb-card class="custom-card mb-0 h-100">
      <nb-card-body>
        <nb-tag-list *ngIf="selectedUsers.length > 0" (tagRemove)="onTagRemove($event)">
          <nb-tag
            *ngFor="let user of selectedUsers"
            [text]="
              user.firstName && user.lastName ? user.firstName + ' ' + user.lastName : user.email
            "
            [attr.data-delete]="user.id"
            removable
          ></nb-tag>
        </nb-tag-list>
        <div *ngIf="selectedUsers.length == 0">
          <h6 class="mb-0">هیچ کاربری انتخاب نشده است</h6>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>
<ng-template #ResultModal let-ref="dialogRef">
  <nb-card style="max-height: 400px;min-width: 500px">
    <nb-card-header>
      <div class="d-flex align-items-center justify-content-between">
        <span>لیست کاربران</span>
        <button nbButton (click)="ref.close()" ghost status="basic"><i class="fal fa-times"></i></button>
      </div>
    </nb-card-header>
    <nb-card-body class="py-0">
      <nb-list-item class="cursor-pointer" (click)="viewHandleName(user);ref.close()"
                    *ngFor="let user of filteredUsers">
        <nb-user *ngIf="user.firstName" [name]="user.firstName + ' ' + user.lastName" [title]="user.email"></nb-user>
        <nb-user *ngIf="user.email && !user.firstName" [name]="user.email" [title]="user.email ?? user.phone"></nb-user>
        <nb-user *ngIf="user.phone && !user.email && !user.firstName" [name]="user.phone"
                 [title]="user.phone"></nb-user>
      </nb-list-item>
    </nb-card-body>
  </nb-card>
</ng-template>
